import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Survey from '../views/Survey'
import ThankYou from '../views/ThankYou'
import Pending from '../views/Pending'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: ThankYou
  },
  {
    path: '/pending',
    name: 'pending',
    component: Pending
  },
  {
    path: '/survey/:survey_hash',
    name: 'survey_hash',
    component: Survey
  }
]

const router = new VueRouter({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
